<template>
	<div class="detail-page">
		<div class="banner">
			<img class="banner-top" src="../assets/detail/top.jpg" />
			<!-- 返回按钮 -->
			<img class="back-btn" src="../assets/detail/back.png" alt="返回" @click="goBack" />
		</div>
		<div class="detail-body">
			<div style="display: flex;align-items: center;justify-content: center;">
				<!-- 学校名称 -->
				<div class="school-name">{{ schoolInfo.schoolname }}</div>
			</div>
			<div class="school-pic">
				<!-- 学校照片 -->
				<img :src="schoolInfo.schoolpic2" style="width: 100%;" v-if="schoolInfo.schoolpic2" />
			</div>
			<div class="jianjie" v-html="schoolInfo.schoolabst"></div>
			<div style="display: flex;align-items: center;justify-content: center;margin-top: 20px;">
				<!-- 校园图集，点此按钮跳转外链 -->
				<img src="../assets/detail/xytj.png" style="width: 30%;" @click="openLink(schoolInfo.xytj)" v-if="schoolInfo.xytj" />
				<!-- 校园咨询，点此按钮跳转外链 -->
				<img src="../assets/detail/xyzx.png" style="width: 30%;margin-left: 15%;" @click="openLink(schoolInfo.xyzx)" v-if="schoolInfo.xyzx" />
			</div>

			<div class="school-msg-show">
				<div style="text-align: center;">
					<img src="../assets/detail/bxlyzsq.png" style="width: 60%;display: inline;" />
				</div>
				<div style="display: flex;align-items: center;justify-content: space-around;margin-top: 20px;">
					<!-- 全部留言按钮 -->
					<img v-if="tab_index==0" @click="tab_index=0" src="../assets/detail/msg1.png"
						style="width: 37%;transform: scale(1.1);" />
					<img v-if="tab_index==1" @click="tab_index=0" src="../assets/detail/msg2.png" style="width: 37%;" />
					<!-- 教师祝福按钮 -->
					<img v-if="tab_index==1" @click="tab_index=1" src="../assets/detail/teacher1.png"
						style="width: 37%;margin-left: 10%;transform: scale(1.1);" />
					<img v-if="tab_index==0" @click="tab_index=1" src="../assets/detail/teacher2.png"
						style="width: 37%;margin-left: 10%;" />
				</div>
				<!-- 全部留言 -->
				<div v-if="tab_index==0">
					<school-message-board :messages="allMessages" :current-page="allMsgPage" :total-pages="allMsgPageCount" @prev-page="prevAllPage" @next-page="nextAllPage" />
				</div>
				<!-- 教师祝福 -->
				<div v-if="tab_index==1">
					<school-message-board :messages="teacherMessages" :current-page="teacherMsgPage" :total-pages="teacherMsgPageCount" @prev-page="prevTeacherPage" @next-page="nextTeacherPage" />
				</div>
			</div>

			<div class="public-view">
				<div class="public-title">
					<img src="../assets/detail/lytjrk.png" alt="公共留言区">
				</div>
				<div class="public-box">
					<input class="input" v-model="username" placeholder="请输入您的姓名/昵称"></input>
				</div>
				<div style="display: flex;padding: 20px 0 10px;padding-left: 15px;">
					<div style="display: flex;align-items: center;" @click="msg_type=0">
						<img v-if="msg_type==0" src="../assets/detail/xz.png" class="xz_icon"/>
						<img v-else src="../assets/detail/wxz.png" class="xz_icon"/>
						<div class="xz_text">所有老师</div>
					</div>
					<div style="display: flex;align-items: center;margin-left: 30px;" @click="msg_type=1">
						<img v-if="msg_type==1" src="../assets/detail/xz.png" class="xz_icon"/>
						<img v-else src="../assets/detail/wxz.png" class="xz_icon"/>
						<div class="xz_text">指定老师</div>
					</div>
				</div>
				<div class="public-box" v-if="msg_type!=null">
					<input v-if="msg_type==0" class="input" :value="'所有老师'" readonly></input>
					<input v-if="msg_type==1" class="input" placeholder="请输入指定老师" v-model="teacher"></input>
				</div>
				<div class="public-box">
					<textarea v-model="content" placeholder="请在此写下对老师的祝福……"></textarea>
				</div>

				<div class="submit-wrap">
				<img src="../assets/shouye/submit.png" alt="提交" @click="addMessage">
			</div>

			</div>
			<!-- 留言成功弹窗 -->
			<div class="success-mask" v-if="showSuccess" @click="showSuccess = false">
				<div style="position: relative;width: 70%;margin: 0 auto;">
					<img src="../assets/lycg.png" style="width: 100%;"/>
					<img src="../assets/sure.png" style="position: absolute;bottom: 15%;left: 35%;width: 30%;"/>
				</div>
			</div>
			<!-- 底部 logo -->
			<div class="footer-logo">
				<img src="../assets/shouye/logo.png">
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getSchoolAllMsgList,getSchoolTeacherMsgList,postReceive,getSchoolDetail
	} from '@/api'
	import { Toast } from 'vant'
	import SchoolMessageBoard from '../components/SchoolMessageBoard.vue'
	export default {
		name: 'detail',
		components: {
			SchoolMessageBoard
		},
		data() {
			return {
				username: null,
				teacher: null,
				content: '',
				tab_index: 0,
				schoolInfo: {
					schoolid: null,
					schoolname: '',
					schoolpic2: '',
					schoolabst: '',
					xytj: '',
					xyzx: ''
				},
				allMessages: [],
				allMsgPage: 1,
				allMsgPageCount: 1,
				teacherMessages: [],
				teacherMsgPage: 1,
				teacherMsgPageCount: 1,
				msg_type:null,
				submitting: false,
				showSuccess: false
			}
		},
		mounted() {
			window.scrollTo(0, 0)
			var query = this.$route.query
			this.schoolInfo = {
				schoolid: query.schoolid,
				schoolname: query.schoolname || '',
				schoolpic2: query.schoolpic2 || '',
				// schoolabst: query.schoolabst ? decodeURIComponent(query.schoolabst) : '',
				xytj: query.xytj || '',
				xyzx: query.xyzx || ''
			}

			this.getAllMessages()
			this.getTeacherMessages()
			this.getSchoolDetailFn()
		},
		methods: {
			goBack() {
				this.$router.back()
			},
			getSchoolDetailFn(){
				getSchoolDetail({schoolid:this.schoolInfo.schoolid}).then(res => {
					var data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
					if (data.code === 1) {
						this.schoolInfo.schoolabst = data.data.schoolabst
						this.$forceUpdate()
					}
				}).catch(() => {
				
				})
			},
			getAllMessages() {
				getSchoolAllMsgList({schoolid:this.schoolInfo.schoolid,pagenow:this.allMsgPage}).then(res => {
					var data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
					if (data.code === 1) {
						this.allMsgPageCount = data.data.pagecount
						this.allMessages = data.data.sublist
					}
				}).catch(() => {

				})
			},
			getTeacherMessages() {
				getSchoolTeacherMsgList({schoolid:this.schoolInfo.schoolid,pagenow:this.teacherMsgPage}).then(res => {
					var data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
					if (data.code === 1) {
						this.teacherMsgPageCount = data.data.pagecount
						this.teacherMessages = data.data.sublist
					}
				}).catch(() => {

				})
			},
			prevAllPage() {
				if (this.allMsgPage > 1) {
					this.allMsgPage--
					this.getAllMessages()
				}
			},
			nextAllPage() {
				if (this.allMsgPage < this.allMsgPageCount) {
					this.allMsgPage++
					this.getAllMessages()
				}
			},
			prevTeacherPage() {
				if (this.teacherMsgPage > 1) {
					this.teacherMsgPage--
					this.getTeacherMessages()
				}
			},
			nextTeacherPage() {
				if (this.teacherMsgPage < this.teacherMsgPageCount) {
					this.teacherMsgPage++
					this.getTeacherMessages()
				}
			},
			openLink(url) {
				if (url) {
					window.location.href = url
				}
			},
			addMessage() {
				if (this.submitting) return
				if (!this.username || !this.username.trim()) {
					Toast('请输入姓名/昵称')
					return
				}
				if (this.msg_type === null) {
					Toast('请选择祝福对象')
					return
				}
				if (this.msg_type === 1 && (!this.teacher || !this.teacher.trim())) {
					Toast('请输入指定老师姓名')
					return
				}
				if (!this.content || !this.content.trim()) {
					Toast('请填写留言内容')
					return
				}
				this.submitting = true
				postReceive({schoolid:this.schoolInfo.schoolid,username:this.username,teacher:this.msg_type==0?'所有老师':this.teacher,content:this.content}).then(res => {
					var data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
					if (data.code === 1) {
						this.showSuccess = true
						this.username = null
						this.teacher = null
						this.content = ''
						this.msg_type = null
						
					}
				}).catch(() => {

				}).finally(() => {
					this.submitting = false
				})
			}
		}
	}
</script>

<style scoped>
	.detail-page {
		max-width: 750px;
		margin: 0 auto;
		min-height: 100vh;
		background: #fdf6e9;
		font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
		color: #a34a1f;
		position: relative;
	}

	.banner {
		position: relative;
	}

	.banner-top {
		width: 100%;
	}

	.back-btn {
		position: fixed;
		top: 12px;
		left: 12px;
		width: 30px;
		cursor: pointer;
		z-index: 10;
	}

	.detail-body {
		background-image: url("../assets/detail/bg.jpg");
		background-size: 100% 100%;
		padding: 0px 12px;
	}

	.school-name {
		background-image: url(../assets/detail/school-name-bg.png);
		background-size: 100% 100%;
		color: #fceac7;
		font-size: 1.3rem;
		font-weight: bold;
		padding: 10px 30px;
	}

	.school-pic {
		margin: 20px auto;
		width: 80%;
		background-image: url(../assets/detail/school-bg.png);
		background-size: 100% 100%;
		padding: 10px;
	}

	.jianjie {
		color: #74270b;
		font-size: 1rem;
		width: 88%;
		margin: 0 auto;
		margin-top: 20px;
	}

	.school-msg-show {
		width: 94%;
		margin: 0 auto;
		margin-top: 30px;
		padding: 20px;
		box-sizing: border-box;
		background-image: url(../assets/shouye/school-msg-box.png);
		background-size: 100% 100%;
	}

	.pager {
		display: flex;
		justify-content: center;
		gap: 44px;
		margin: 22px 0 0px;
	}

	.pager img {
		width: 106px;
		cursor: pointer;
	}
	
	.pager img.disabled {
		opacity: 0.4;
		pointer-events: none;
	}

	.xz_icon{
		width: 1.3rem;
	}
	.xz_text{
		font-size: 1.05rem;
		font-weight: bold;
		margin-left: 3px;
	}
	.public-view {
		background: url("../assets/shouye/public-box.png") no-repeat center / 100% 100%;
		padding: 40px 15px 20px;
		margin: 0 5px;
		margin-top: 30px;
	}

	.public-title {
		display: flex;
		justify-content: center;
		margin-bottom: 16px;
	}

	.public-title img {
		width: 60%;
	}
	.input{
		width: 100%;
		height: 40px;
		border-radius: 5px;
		padding-left: 10px;
		border: 1px solid #781a00;
		outline: none;
		resize: none;
		background: transparent;
		font-size: 1rem;
		color: #8a4a2a;
		font-family: inherit;
	}
	.public-box {

		padding: 10px 15px 0;
	}

	.public-box textarea {
		width: 100%;
		height: 150px;
		border-radius: 5px;
		padding: 5px 10px;
		border: 1px solid #781a00;
		outline: none;
		resize: none;
		background: transparent;
		font-size: 1rem;
		line-height: 1.8;
		color: #8a4a2a;
		font-family: inherit;
	}

	.submit-wrap {
		display: flex;
		justify-content: center;
		margin: 10px 0 30px;
	}

	.submit-wrap img {
		width: 35%;
		cursor: pointer;
	}

	.tips {
		display: flex;
		justify-content: center;
		margin-bottom: 34px;
	}

	.tips img {
		width: 88%;
	}

	.footer-logo {
		display: flex;
		justify-content: center;
		margin-top: 30px;
	}

	.footer-logo img {
		width: 35%;
		padding-bottom: 30px;
	}

	.success-mask {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.6);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 999;
	}

	.success-img {
		width: 70%;
		max-width: 400px;
	}
</style>